import { render, staticRenderFns } from "./OrderTypeButtons.vue?vue&type=template&id=916c2b50&"
import script from "./OrderTypeButtons.vue?vue&type=script&lang=js&"
export * from "./OrderTypeButtons.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeButtons.vue?vue&type=style&index=0&id=916c2b50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports